import { Component, OnInit, Output, EventEmitter, Input } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { ScpwDataService } from 'projects/scpw-ssc/src/app/scpw-ssc/scpw-services/scpw-data.service';
import { map } from 'rxjs';

@Component({
  selector: 'app-expo-search-box',
  templateUrl: './expo-search-box.component.html',
  styleUrls: ['./expo-search-box.component.css']
})
export class ExpoSearchBoxComponent implements OnInit {
  disabilityTypeList = [];
  DisabilityCategoryData = [];
  ExpositoryStatus = [];
  ExpositoryDetails: any;
  filterForm: FormGroup;
  @Input() expositoryStatus;
  @Output() dataSearch = new EventEmitter<any>();
  
  constructor(
    private _scpwDataService: ScpwDataService,
		private formBuilder: FormBuilder,
  ) { 
    this.filterForm = formBuilder.group({
			disabilitytype: ['All'],
			disabilitycategory: ['All'],
			status: ['All'],
			keyword: [''],
		})
  }

   ngOnInit() {
   	this.getAllDisabilityTypes();
   	this.getDisabilityCategoryList();
   }
  
	
   getDisabilityCategoryList() {
	this._scpwDataService.getAllDisabilityCategories()
	.pipe(map((status: any) => {
		return status.map(cat => {
			return {
				'id': cat.pwdID,
				'Category': cat.pwdDesc,
			}
		})

	}))
	.subscribe(data => {
		this.DisabilityCategoryData = data;
	})


   // this.DisabilityCategoryData = [{
   // 		id: '1',
   // 		Category: 'Physical Disability/Physically Handicapped'
   // 	},
   // 	{
   // 		id: '2',
   // 		Category: 'Visual Impairment/ Visually Impaired '
   // 	},
   // 	{
   // 		id: '3',
   // 		Category: 'Hearing impairment/Hearing Impaired'
   // 	},
   // 	{
   // 		id: '4',
   // 		Category: 'Intellectual disability/Mental Illness '
   // 	},
   // 	{
   // 		id: '5',
   // 		Category: 'Multiple Disabilities'
   // 	}
   // ]
}

  
   getAllDisabilityTypes() {
   	this._scpwDataService.getAllDisabilityTypes().subscribe(res => {
   		this.disabilityTypeList = res;
   	}, err => {
   		console.log(err);
   	});
   }

   searchData() {
   	this.dataSearch.emit(this.filterForm.getRawValue());
   }

   resetFilter() {
   	this.filterForm.get('disabilitytype').setValue('All');
   	this.filterForm.get('disabilitycategory').setValue('All');
   	this.filterForm.get('status').setValue('All');
   	this.filterForm.get('keyword').setValue('');
   	this.dataSearch.emit(this.filterForm.getRawValue());
   }
}
